module.exports = __webpack_public_path__ + "static/media/stripe-onboarding_5.766d2f39.png";